export const _98976List = [
  'Asthma',
  'COPD',
  'Bronchitis',
  'Pneumonia',
  'Lung cancer',
  'Pulmonary edema',
  'Emphysema'
]

export const _98977List = [
  'Arthritis',
  'Back pain',
  'Trauma',
  'Degenerative disease',
  'Gait abnormality'
]
